import { useEffect, useRef, useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../../../hoc/toJS';
import getData from '../../../functions/getData'
import { CLI, CLI_CINEMA_CLIENT_ID, CLI_MULTICINEMA_MODE, FLYER_DATA, UI_GENERAL, PROGRAM_ATTRIBUTES_GLOBAL, PROGRAM_ATTRIBUTES, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_CLI_MOVIES_ORDER, PROGRAM_PERFORMANCES, ROUTES_DATA, TRANSLATION, UI_PROGRAM, PUSH_DATA_CURRENT_WEEK, PUSH_CREATE_DATA, PUSH_CREATE_CURRENT_WEEK, PUSH_CREATE_STATUS, PROGRAM_CINEMAS, PROGRAM_ADS_ITEMS, PROGRAM_HIGHLIGHTS } from '../../../constants/state'
import hasUpdateProgram from '../../../hoc/hasUpdateProgram';
import pushConfig from '../../../push-config.json'
import config from '../../../config.json'
import PushCreatePage from '../present/create/PushCreatePage';
import filterItemsByOrder from '../../../functions/cinemaAndTimeRangeFilters/filterItemsByOrder';
import { AD, HIGHLIGHT, MOVIE } from '../../../constants/itemTypes';
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple';
import Translation from '../../Translation/cont/Translation';
import OverlayNonSiOhhh from '../../overlay/presentational/OverlayNonSiOhhh';
import OverlayText from '../../overlay/presentational/OverlayText';
import OverlayWrapper from '../../overlay/presentational/OverlayWrapper';
import actionTypes from '../../../actions/actionTypes';
import { OVERLAY_PUSH_YES_NO } from '../../../constants/overlayTypes';
import { pushCreateAttachedItemUpdate, pushCreateFormUpdate, pushCreateRequest, uiRequestOverlayReset, uiSetRequestOverlayRequest, uiSetRequestOverlayType } from '../../../actions';
import requestStatus from '../../../constants/requestStatus';
import { getFromWeekCinemaEndDate, getFromWeekCinemaStartDate } from '../../../functions/getDateFromWeek';
import filterMoviesByTimeRangeAndCinema from '../../../functions/cinemaAndTimeRangeFilters/filterMoviesByTimeRangeAndCinema';
import getCinemaIdsByMovie from '../../../functions/cinemaAndTimeRangeFilters/getCinemaIdsByMovie';
import sortCinemas from '../../../functions/sortCinemas';
import resolveAdLinkUrl from '../functions/resolveAdLinkUrl';

const mapStateToProps = (state, ownProps) => ({
    attributes: getData(state, PROGRAM_ATTRIBUTES_GLOBAL),
    attributesData: getData(state, PROGRAM_ATTRIBUTES),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    currentClientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    currentWeek: getData(state, [PUSH_CREATE_CURRENT_WEEK]),
    displayDropzones: getData(state, [UI_PROGRAM, 'activeDropzones']),
    displayDropzones: getData(state, [UI_PROGRAM, 'activeDropzones']),
    displayMovies: true,
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    movieOrder: getData(state, PROGRAM_CLI_MOVIES_ORDER),
    adsData: getData(state, PROGRAM_ADS_ITEMS),
    highlightsData: getData(state, PROGRAM_HIGHLIGHTS),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),
    performancesData: getData(state, PROGRAM_PERFORMANCES),
    pushCreateData: getData(state, [PUSH_CREATE_DATA]),
    routesData: getData(state, ROUTES_DATA),
    status: getData(state, [PUSH_CREATE_STATUS]),
    translation: getData(state, TRANSLATION),
    appScheme: getData(state, [CLI, 'apps', 'push', 'app_scheme']),
    uiRequestOverlay: getData(state, [UI_GENERAL, 'requestOverlay']),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onCreatePush: (mode = "Default") => {
        dispatch(pushCreateRequest(mode))
    },
    onRequestCreatePush: () => {
        dispatch(uiSetRequestOverlayType(OVERLAY_PUSH_YES_NO))
        dispatch(uiSetRequestOverlayRequest(actionTypes.PUSH_CREATE_REQUEST))
    },
    onCancelCreatePush: () => {
        dispatch(uiRequestOverlayReset())
    },
    onFormUpdate: (itemData) => {
        dispatch(pushCreateFormUpdate(itemData))
    },
    onAttachedItemUpdate: (attachedItemData) => {
        dispatch(pushCreateAttachedItemUpdate(attachedItemData))
    },
})

const dragListConfig = [
    {
        titleTransId: 'program_list_content_selection',
        buttonTextTransId: null,
        type: AD,
        dataType: 'contentItems',
        hasAddNewItem: false,
        hasRemoveItem: false
    },
    {
        titleTransId: 'program_list_highlight_selection',
        buttonTextTransId: null,
        type: HIGHLIGHT,
        dataType: 'highlightItems',
        hasAddNewItem: false,
        hasRemoveItem: false
    },
    {
        titleTransId: 'section_filter_current_movies',
        buttonTextTransId: null,
        type: MOVIE,
        dataType: 'currentMovies',
        hasAddNewItem: false,
        hasRemoveItem: false
    },
    {
        titleTransId: 'print_upcoming_movies',
        buttonTextTransId: null,
        type: MOVIE,
        dataType: 'futureMovies',
        hasAddNewItem: false,
        hasRemoveItem: false
    },
    // {
    //     titleTransId: 'print_flyer_image_elements_selection',
    //     buttonTextTransId: 'print_flyer_new_image_element',
    //     type: IMAGE,
    //     itemsType: 'imageElements',
    //     hasAddNewItem: true,
    //     hasRemoveItem: true
    // }
]

const PushCreateContainer = ({
    adsData,
    attributesData,
    basicUrl,
    cliCinemas,
    clientCinemaId,
    currentWeek,
    displayDropzones,
    highlightsData,
    movieData,
    movieOrder,
    onAttachedItemUpdate,
    onCreatePush,
    onRequestCreatePush,
    onCancelCreatePush,
    onFormUpdate,
    performancesData,
    pushCreateData,
    routesData,
    status,
    appScheme,
    translation,
    uiRequestOverlay
}) => {
    const [requestedMode, setRequestedMode] = useState("Default")
    const [isSending, setIsSending] = useState(false)
    const [sendingMode, setSendingMode] = useState(false)
    const [successMode, setSuccessMode] = useState(false)
    const [resultOverlayType, setResultOverlayType] = useState(false)
    const [showTestModeOverlay, setShowTestModeOverlay] = useState(false)
    const [pendingAutofill, setPendingAutofill] = useState(false)
    const [autofillRequest, setAutofillRequest] = useState(false)
    const prevStatusRef = useRef(status)

    const toPlainText = (value) => {
        if(!value || typeof value !== 'string') {
            return ''
        }
        return value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
    }

    const clamp = (value, maxLength) => {
        const currentValue = value || ''
        return currentValue.length > maxLength ? currentValue.substring(0, maxLength) : currentValue
    }

    const getAutofillFromAttachment = (attachedItemData) => {
        const item = attachedItemData?.item

        if(!item || !attachedItemData?.itemType) {
            return false
        }

        let title = ''
        let body = ''

        let linkUrl = ''
        let linkDestinationType = 'internal'

        if(attachedItemData.itemType === MOVIE) {
            title = item?.titleDisplay || item?.title || ''
            body = item?.descriptionShort || item?.description || item?.subTitle || ''
            linkUrl = ''
            linkDestinationType = 'internal'
        } else if(attachedItemData.itemType === HIGHLIGHT) {
            const referencedMovie = item?.referencedMovie || (item?.movieRefID && movieData?.[item.movieRefID] ? movieData[item.movieRefID] : null)
            const sourceItem = referencedMovie || item
            title = sourceItem?.titleDisplay || sourceItem?.title || item?.title || item?.headlineClient || ''
            body = sourceItem?.descriptionShort || sourceItem?.description || sourceItem?.subTitle || item?.description || ''
            linkUrl = ''
            linkDestinationType = 'internal'
        } else if(attachedItemData.itemType === AD) {
            title = item?.title || item?.titleDisplay || item?.headlineClient || item?.name || ''
            body = item?.descriptionShort || item?.description || item?.subTitle || item?.text || ''
            const frontpageUrl = routesData?.frontpage?.[translation?.currentLang]?.uri || ''
            linkUrl = resolveAdLinkUrl(item?.link, frontpageUrl)
            linkDestinationType = item?.link?.destinationType === 'external' ? 'external' : 'internal'
        } else {
            return false
        }

        return {
            title: clamp(toPlainText(title), 20),
            body: clamp(toPlainText(body), 220),
            linkUrl: clamp(`${linkUrl || ''}`.trim(), 2000),
            linkDestinationType,
            requestId: `${attachedItemData.itemType}-${attachedItemData.itemId}-${Date.now()}`
        }
    }

    const hasFormText = (formData) => {
        const title = formData?.title ? `${formData.title}`.trim() : ''
        const body = formData?.body ? `${formData.body}`.trim() : ''
        const linkUrl = formData?.link?.url ? `${formData.link.url}`.trim() : ''
        return title.length > 0 || body.length > 0 || linkUrl.length > 0
    }

    const onAttachedItemUpdateWithAutofill = (attachedItemData) => {
        onAttachedItemUpdate(attachedItemData)

        if(!attachedItemData) {
            return
        }

        const autofillData = getAutofillFromAttachment(attachedItemData)

        if(!autofillData) {
            return
        }

        if(hasFormText(pushCreateData?.form)) {
            setPendingAutofill(autofillData)
            return
        }

        setAutofillRequest(autofillData)
    }

    useEffect(() => {
        const prevStatus = prevStatusRef.current

        if(status === requestStatus.REQUEST_PENDING) {
            setIsSending(true)
        }

        if(prevStatus === requestStatus.REQUEST_PENDING && status === requestStatus.REQUEST_SUCCESS) {
            setSuccessMode(sendingMode)
            setIsSending(false)
            setSendingMode(false)
            setResultOverlayType('success')
        } else if(prevStatus === requestStatus.REQUEST_PENDING && status === requestStatus.REQUEST_ERROR) {
            setIsSending(false)
            setSendingMode(false)
            setResultOverlayType('error')
        }

        prevStatusRef.current = status
    }, [status])

    const weekPeriodeStartDate = getFromWeekCinemaStartDate(currentWeek.isoWeek, currentWeek.year)
    const weekPeriodeEndDate = getFromWeekCinemaEndDate(currentWeek.isoWeek, currentWeek.year)
    const relevantMovies =  filterMoviesByTimeRangeAndCinema(movieOrder, movieData, performancesData, weekPeriodeStartDate, weekPeriodeEndDate, pushCreateData.form.cinemasFilter)

    let selectedMovies = []
    let selectedAds = []
    let selectedHighlights = []
    let enabledCinemaIds = sortCinemas(clientCinemaId, cliCinemas)
    
    if(pushCreateData?.attachedItem?.itemId && pushCreateData?.attachedItem?.itemType === MOVIE){
        const movieId = pushCreateData.attachedItem.itemId
        selectedMovies = [movieId]
        enabledCinemaIds = getCinemaIdsByMovie(movieData, performancesData, movieId, weekPeriodeStartDate, weekPeriodeEndDate)
    } else if(pushCreateData?.attachedItem?.itemId && pushCreateData?.attachedItem?.itemType === AD) {
        selectedAds = [pushCreateData.attachedItem.itemId]
    } else if(pushCreateData?.attachedItem?.itemId && pushCreateData?.attachedItem?.itemType === HIGHLIGHT) {
        selectedHighlights = [pushCreateData.attachedItem.itemId]
    }

    const selectedCinemaIds = pushCreateData?.form?.cinemasFilter || []
    const selectedCinemaFilter = selectedCinemaIds.map(id => `${id}`)
    const isInAllSelectedCinemas = (itemCinemas = []) => {
        const itemCinemaFilter = (itemCinemas || []).map(id => `${id}`)
        if(selectedCinemaFilter.length === 0) {
            return true
        }
        return selectedCinemaFilter.reduce((acc, current) => acc && itemCinemaFilter.includes(current), true)
    }

    const filteredAdOrder = Object.keys(adsData || {}).filter(itemId => {
        return isInAllSelectedCinemas(adsData?.[itemId]?.cinemasFilter || [])
    })
    const filteredHighlightOrder = Object.keys(highlightsData || {}).filter(itemId => {
        return isInAllSelectedCinemas(highlightsData?.[itemId]?.cinemasFilter || [])
    })
    
    const movieItemsData = {
        order: relevantMovies.relevant,
        items: filterItemsByOrder(relevantMovies.relevant, movieData),
        selectedItems: selectedMovies,
        current: relevantMovies.current,
        future: relevantMovies.future,
        attributes: attributesData,
        enabledCinemaIds: enabledCinemaIds
    }

    const contentItemsData = {
        order: filteredAdOrder,
        items: filterItemsByOrder(filteredAdOrder, adsData || {}),
        selectedItems: selectedAds
    }

    const highlightItemsData = {
        order: filteredHighlightOrder,
        items: filterItemsByOrder(filteredHighlightOrder, highlightsData || {}),
        selectedItems: selectedHighlights
    }

    const closePagePath = config.routes.apps.path
    const disableButton = pushCreateData?.form?.valid != true
    let overlay = ''
    const normalizedAppScheme = typeof appScheme === 'string' ? appScheme.trim().replace(/:\/+$/, '') : ''
    const hasAppScheme = normalizedAppScheme.length > 0
    const testModeQrPayload = `${normalizedAppScheme}://test-mode/toggle`
    const testModeQrData = encodeURIComponent(testModeQrPayload)
    const testModeQrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=560x560&data=${testModeQrData}`
    const successText = successMode === "Test"
        ? 'Hinweis: Push-Nachrichten werden nur empfangen, wenn die App im Hintergrund ist.'
        : ''

    if(showTestModeOverlay && hasAppScheme) {
        overlay = <OverlayWrapper>
                <div className='title-large-color text'>Testmodus aktivieren</div>
                <p className="text-large-light text">
                    Scanne den QR-Code mit deinem Smartphone, um den Testmodus in der App zu aktivieren oder zu deaktivieren.
                </p>
                <div style={{display: 'flex', justifyContent: 'center', marginTop: '32px', marginBottom: '20px'}}>
                    <img src={testModeQrSrc} alt="Testmodus QR-Code" width="280" height="280" />
                </div>
                <div className="save-button-wrapper">
                <button className="button-save" onClick={() => setShowTestModeOverlay(false)}>
                    <span className=''><Translation id='button_close'/></span>
                </button>
            </div>
        </OverlayWrapper>
    } else if(pendingAutofill) {
        overlay = <OverlayNonSiOhhh
            titleTransId='push_dialog_overwrite_title'
            text='Sollen die vorhandenen Inhalte mit dem ausgewählten Element überschrieben werden?'
            nonButtonTextTransId="cancel_button"
            nonOnClickButton={() => setPendingAutofill(false)}
            siButtonTextTransId='push_dialog_overwrite_button_yes'
            siOnClickButton={() => {
                setAutofillRequest(pendingAutofill)
                setPendingAutofill(false)
            }}
        />
    } else if(uiRequestOverlay.requestType === actionTypes.PUSH_CREATE_REQUEST && uiRequestOverlay.overlayType === OVERLAY_PUSH_YES_NO) {
        overlay = <OverlayNonSiOhhh
            titleTransId='push_create_name'
            text=''
            nonButtonTextTransId="cancel_button"
            nonOnClickButton={() => onCancelCreatePush()}
            siButtonTextTransId='push_create_button'
            siOnClickButton={() => onCreatePush(requestedMode)}
        />
    } else if(resultOverlayType === 'success') {
        overlay = <OverlayText
            titleTransId='push_create_button_sent'
            text={successText}
            buttonTextTransId='button_close'
            onClickButton={() => {
                setResultOverlayType(false)
                setSuccessMode(false)
                onCancelCreatePush()
            }}
        />
    } else if(resultOverlayType === 'error') {
        overlay = <OverlayText
            titleTransId='push_error'
            text={pushCreateData?.error ? pushCreateData.error : ''}
            buttonTextTransId='button_close'
            onClickButton={() => {
                setResultOverlayType(false)
                onCancelCreatePush()
            }}
        />
    }

    return (
        <WrapperPageSimple
            pageTitle={[<Translation key="name_one" id={pushConfig.routes["create"].transIdname} />]}
            closePagePath={closePagePath}
            overlay={overlay} >
            <PushCreatePage
                key={pushCreateData.key}
                basicUrl={basicUrl}
                cliCinemas = {cliCinemas}
                clientCinemaId = {clientCinemaId}
                closePagePath={closePagePath}
                disableButton={disableButton}
                displayDropzones={displayDropzones}
                dragListConfig={dragListConfig}
                movieItemsData={movieItemsData}
                contentItemsData={contentItemsData}
                highlightItemsData={highlightItemsData}
                movieItemsDataCallback={itemsDataCallback}
                onAttachedItemUpdate={onAttachedItemUpdateWithAutofill}
                onCreatePush={(mode = "Default") => {
                    setSendingMode(mode)
                    if(mode === "Test") {
                        onCreatePush("Test")
                        return
                    }

                    setRequestedMode(mode)
                    onRequestCreatePush(mode)
                }}
                onOpenTestModeQr={() => setShowTestModeOverlay(true)}
                appScheme={normalizedAppScheme}
                isSending={isSending}
                sendingMode={sendingMode}
                onFormUpdate={onFormUpdate}
                autofillRequest={autofillRequest}
                pushCreateData={pushCreateData}
                week={currentWeek}
            />
        </WrapperPageSimple>
    )
}

function itemsDataCallback(dataType, itemsData) {
    let itemsOrder = []
    let items = itemsData.items
    let selected = itemsData.selectedItems

    if ('contentItems' === dataType) {
        items = itemsData.contentItems
        itemsOrder = itemsData.contentOrder
        selected = itemsData.selectedContentItems
    } else if ('highlightItems' === dataType) {
        items = itemsData.highlightItems
        itemsOrder = itemsData.highlightOrder
        selected = itemsData.selectedHighlightItems
    }

    if ('currentMovies' === dataType) {
        itemsOrder = itemsData.current
    } else if ('futureMovies' === dataType) {
        itemsOrder = itemsData.future
    }

    return {
        items: items,
        order: itemsOrder,
        selected: selected
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    hasUpdateProgram(),
    toJS()
)(PushCreateContainer)
